import ServerTimeoutPage from "./ServerTimeoutPage";

export {ServerTimeoutPage}
export default ServerTimeoutPage
